import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { about, AboutSection } from '../data/about';

import './about.css';

const aboutBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/about_background.jpg'})`,
};

export default class AboutPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  aboutSection({ prompt, details }: AboutSection): JSX.Element {
    return (
      <p key={prompt}>
        <h2 className="title is-5">{prompt}:</h2>
        <p className="subtitle is-6">{details}</p>
      </p>
    );
  }

  render(): JSX.Element {
    return (
      <section className="section about background escape-nav" style={aboutBackground}>
        <div className="container">
          <div className="card box is-centered">
            <div className="card-content is-hidden-mobile">
              <h1 className="title is-3 has-text-centered is-shadowed is-cursive">Briana &amp; Matt</h1>
            </div>
            <div className="card-image">
              <figure className="image is-4by3">
                <img src={`${process.env.PUBLIC_URL}/img/about_couple.jpg`} alt="Briana &amp; Matt" />
              </figure>
            </div>
            <div className="card-content">
              <div className="content has-text-justified">{about.map(section => this.aboutSection(section))}</div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/about.tsx